import {
    useState,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import requests from 'app/requests/ServiceCenter/ServiceCenter.requests'

import {
    OperationalHour,
} from '../serviceCenters.types'
import getWorkScheduleFields from './workSchedule.fields'
import useStyles from './workSchedule.style'

type WorkScheduleData = {
    breakStartsAt: string,
    breakEndsAt: string,
    operationalHours: OperationalHour[],
    isLunchBreak: boolean,
}

const WorkSchedule = ({
    data,
    onSuccess,
    id,
}: Readonly<{
    data: WorkScheduleData,
    onSuccess: () => void,
    id: number,
}>) => {
    const {
        classes,
    } = useStyles()

    const [
        value,
        setValue,
    ] = useState<WorkScheduleData>(data)

    const fields = useFieldsWithClassName(getWorkScheduleFields({
        isLunchBreak: value?.isLunchBreak,
    }), classes)

    const onChange = (newVal: WorkScheduleData) => {
        setValue(!newVal?.isLunchBreak && (newVal?.breakStartsAt || newVal?.breakEndsAt)
            ? {
                ...newVal,
                breakStartsAt: undefined,
                breakEndsAt: undefined,
            } : newVal)
    }

    const modifyDataBeforeSend = ({
        isLunchBreak, ...formData // eslint-disable-line @typescript-eslint/no-unused-vars
    }: WorkScheduleData) => {
        return formData
    }

    return (
        <FormWithControls
            name="WorkSchedule"
            value={value}
            classNames={{
                gridCardWrapper: classes.gridWrapper,
            }}
            fields={fields}
            setExternalValue={onChange}
            requestParams={requests.updateWorkSchedule({
                id,
            })}
            exists
            onSuccess={onSuccess}
            modifyDataBeforeSend={modifyDataBeforeSend}
        />
    )
}

export default WorkSchedule
